import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { DataRecency } from "src/types"

export function isBatteryLow(
  batteryPercent: PumpStatus["battery_percent"],
  pumpStatusRecency: DataRecency,
) {
  return (
    batteryPercent !== null &&
    batteryPercent <= 20 &&
    pumpStatusRecency !== DataRecency.Stale
  )
}
